export default "__VITE_ASSET__Bu7V9yxR__"